import {
  matchesOmniFilter as matchesOmniFilterGeneric,
  parseOmniQuery as parseOmniQueryGeneric,
  type OmniFieldDef,
  type OmniFields,
  type ParsedOmniQuery,
} from '@lib/utils/omniFilter';
import type { LibraryStore } from '@stores/Library/Library';

/**
 * Libraries binding for the generic omnifilter engine (`@lib/utils/omniFilter`).
 *
 * A library is shown if **any** space-separated token matches by:
 *   - substring of the library name (case-insensitive), OR
 *   - exact library ID.
 *
 * (No YouTube ID here — libraries have no origin URL.)
 */

export type LibraryOmniReason = 'name' | 'libraryId';

export const LIBRARY_OMNI_FIELDS: readonly OmniFieldDef<LibraryOmniReason>[] = [
  { reason: 'name', label: 'name', mode: 'substring' },
  { reason: 'libraryId', label: 'library ID', mode: 'exact' },
];

export type LibraryOmniFields = OmniFields<LibraryOmniReason>;

export const parseLibraryOmniQuery = (
  query: string | null | undefined,
  matchAll = false,
): ParsedOmniQuery | null => parseOmniQueryGeneric(query, LIBRARY_OMNI_FIELDS, matchAll);

export const matchesLibraryOmniFilter = (
  fields: LibraryOmniFields,
  parsed: ParsedOmniQuery,
): boolean => matchesOmniFilterGeneric(fields, parsed, LIBRARY_OMNI_FIELDS);

/** Extract the omnifilter match fields from a library store. */
export function getLibraryOmniFields(library: LibraryStore): LibraryOmniFields {
  return {
    name: library.name,
    libraryId: library.libraryId,
  };
}
